import { render, staticRenderFns } from "./JudgementListSummary.vue?vue&type=template&id=efed5154&"
import script from "./JudgementListSummary.vue?vue&type=script&lang=ts&"
export * from "./JudgementListSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports